import { Text, useTranslation, styled } from '@obvio/app'
import { Form, FormPage, FormTabs } from '@obvio/ui'

import { FormArtworks } from './FormJoin/FormArtworks'
import { ArtworksContextProvider } from './FormJoin/FormArtworksContext'
import { FormContinue } from './FormJoin/FormContinue'
import { FormDetails } from './FormJoin/FormDetails'
import { FormJoinContact } from './FormJoin/FormJoinContact'
import { FormJoinPersonal } from './FormJoin/FormJoinPersonal'
import { FormJoinSummary } from './FormJoin/FormJoinSummary'
import { FormSection } from './FormJoin/FormSection'
import { useFormJoinSubmit } from './FormJoin/useFormJoinSubmit'
import { FadeIn } from '../FadeIn'

import type { TabData } from '@obvio/ui'
import type { ReactElement } from 'react'

const tabs: TabData[] = [
  {
    title: 'About you',
    description: 'Fill out your personal details',
  },
  {
    title: 'Artworks',
    description: 'Upload and describe each pieace of your art',
  },
  {
    title: 'Submit',
    description: 'Review and submit your application',
  },
]

const FormTabsSticky = styled(FormTabs)`
  position: sticky;
  top: calc(
    var(--nav-height) - calc(${(theme) => theme.spacing.extraLarge} * 1.5) +
      1rem
  );
  z-index: 3;
  background-color: white;
`

function InnerForm(): ReactElement {
  const { t } = useTranslation()
  const handleSubmit = useFormJoinSubmit()

  return (
    <Form onSubmit={handleSubmit}>
      <FormTabsSticky tabs={tabs} />
      <FormPage>
        <FadeIn>
          <FormSection title="Contact">
            <FormJoinContact />
          </FormSection>
          <FormSection
            title="Personal information"
            description="This will help us get to know you better and evaluate your qualifications for joining Fijewski Gallery."
          >
            <FormJoinPersonal />
          </FormSection>
          <FormSection
            title="Details"
            description="If your application is approved, this information will be used to create your artist page on the Fijewski Gallery website."
          >
            <FormDetails />
          </FormSection>
          <FormContinue />
        </FadeIn>
      </FormPage>
      <FormPage>
        <FadeIn>
          <FormArtworks />
        </FadeIn>
      </FormPage>
      <FormPage>
        <FadeIn>
          <FormJoinSummary />
        </FadeIn>
      </FormPage>
      <FormPage successPage>
        <FadeIn>
          <Text tag="h2" as="h4">
            {t('joinForm.sent')}
          </Text>
        </FadeIn>
      </FormPage>
    </Form>
  )
}

export function FormJoin(): ReactElement {
  return (
    <ArtworksContextProvider>
      <InnerForm />
    </ArtworksContextProvider>
  )
}
